export const bodys = [
        {
            "code":"310115",
            "sellPrice":2490,
            "name":"浦东",
            "count":"0",
            "longitude":"121.606531",
            "latitude":"31.208002",
            "touch_lng":"121.592597",
            "touch_lat":"31.283966"
        },
        {
            "code":"310112",
            "sellPrice":1990,
            "name":"闵行",
            "count":"0",
            "longitude":"121.408171",
            "latitude":"31.091186",
            "touch_lng":"121.304717",
            "touch_lat":"31.221620"
        },
        {
            "code":"310113",
            "sellPrice":2130,
            "name":"宝山",
            "count":"0",
            "longitude":"121.428830",
            "latitude":"31.369478",
            "touch_lng":"121.381863",
            "touch_lat":"31.366819"
        },
        {
            "code":"310114",
            "sellPrice":2130,
            "name":"嘉定",
            "count":"0",
            "longitude":"121.285054",
            "latitude":"31.318139",
            "touch_lng":"121.313125",
            "touch_lat":"31.264967"
        },
        {
            "code":"310107",
            "sellPrice":4090,
            "name":"普陀",
            "count":"0",
            "longitude":"121.407503",
            "latitude":"31.256756",
            "touch_lng":"121.442085",
            "touch_lat":"31.269952"
        },
        {
            "code":"310104",
            "sellPrice":5730,
            "name":"徐汇",
            "count":"0",
            "longitude":"121.445113",
            "latitude":"31.175099",
            "touch_lng":"121.441618",
            "touch_lat":"31.200958"
        },
        {
            "code":"310117",
            "sellPrice":2290,
            "name":"松江",
            "count":"0",
            "longitude":"121.265155",
            "latitude":"31.045702",
            "touch_lng":"121.322898",
            "touch_lat":"31.142778"
        },
        {
            "code":"310110",
            "sellPrice":2760,
            "name":"杨浦",
            "count":"0",
            "longitude":"121.535920",
            "latitude":"31.294893",
            "touch_lng":"121.515279",
            "touch_lat":"31.333991"
        },
        {
            "code":"310105",
            "sellPrice":5360,
            "name":"长宁",
            "count":"0",
            "longitude":"121.387923",
            "latitude":"31.211509",
            "touch_lng":"121.421632",
            "touch_lat":"31.223490"
        },
        {
            "code":"310109",
            "sellPrice":5690,
            "name":"虹口",
            "count":"0",
            "longitude":"121.489512",
            "latitude":"31.283347",
            "touch_lng":"121.504428",
            "touch_lat":"31.269288"
        },
        {
            "code":"310108",
            "sellPrice":3090,
            "name":"新静安",
            "count":"0",
            "longitude":"121.451768",
            "latitude":"31.287034",
            "touch_lng":"121.463860",
            "touch_lat":"31.256370"
        },
        {
            "code":"310101",
            "sellPrice":13060,
            "name":"黄浦",
            "count":"0",
            "longitude":"121.488587",
            "latitude":"31.220653",
            "touch_lng":"121.496963",
            "touch_lat":"31.214851"
        },
        {
            "code":"310118",
            "sellPrice":5060,
            "name":"青浦",
            "count":"0",
            "longitude":"121.216900",
            "latitude":"31.196892",
            "touch_lng":"121.098795",
            "touch_lat":"31.156357"
        },
        {
            "code":"310106",
            "sellPrice":10290,
            "name":"静安",
            "count":"0",
            "longitude":"121.456090",
            "latitude":"31.236320",
            "touch_lng":"121.462729",
            "touch_lat":"31.236534"
        },
        {
            "code":"310120",
            "sellPrice":1690,
            "name":"奉贤",
            "count":"0",
            "longitude":"121.445025",
            "latitude":"30.999746",
            "touch_lng":"121.445025",
            "touch_lat":"30.999746"
        }
]
export const plate = [
    {"name":'宝山城市工业园区',"longitude":"121.356134","latitude":"31.316335","count":0},
    {"name":'宝山工业园区',"longitude":"121.354869","latitude":"31.462817","count":0},
    {"name":'吴淞街道',"longitude":"121.500597","latitude":"31.378195","count":0},
    {"name":'张庙街道',"longitude":"121.448251","latitude":"31.342986","count":0},
    {"name":'友谊路街道',"longitude":"121.493749","latitude":"31.40317","count":0},
    {"name":'庙行镇',"longitude":"121.43463","latitude":"31.33496","count":0},
    {"name":'罗店镇',"longitude":"121.362304","latitude":"31.401138","count":0},
    {"name":'大场镇',"longitude":"121.423427","latitude":"31.293055","count":0},
    {"name":'顾村镇',"longitude":"121.413534","latitude":"31.355538","count":0},
    {"name":'罗泾镇',"longitude":"121.333952","latitude":"31.478501","count":0},
    {"name":'杨行镇',"longitude":"121.44495","latitude":"31.371027","count":0},
    {"name":'月浦镇',"longitude":"121.428219","latitude":"31.426486","count":0},
    {"name":'淞南镇',"longitude":"121.49635","latitude":"31.353722","count":0},
    {"name":'高境镇',"longitude":"121.489139","latitude":"31.326897","count":0},
   ]

